import "./App.css";
import Landing from "./components/pages/Landing";
import { BrowserRouter, Route, Switch, useHistory } from "react-router-dom";
import React, { useContext, useEffect, createContext } from "react";
import SignIn from "./components/pages/SignIn";
import SignUp from "./components/pages/SignUp";
import Front from "./components/pages/Front/Front";
import SearchedResult from "./components/pages/Front/SearchedResult";
import Folio from "./components/pages/Folios/Folio";
import About from "./components/pages/About";
import TermsOfService from "./components/pages/TermsOfService";
import PrivacyPolicy from "./components/pages/PrivacyPolicy";
import FAQs from "./components/pages/FAQs";
import Contact from "./components/pages/Contact";
import FullScreen from "./components/pages/Folios/FullScreen";
import Saved from "./components/pages/Folios/Saved";
import User from "./components/pages/Folios/User";
import Upload from "./components/pages/Folios/Upload";
import File from "./components/pages/File";
import Attributes from "./components/pages/Attributes";
import settings from "./components/pages/SettingAcc";
import settingsFeed from "./components/pages/SettingFeed";
import settingsnotifi from "./components/pages/SettingNoti";
import AllCategory from "./components/pages/Folios/AllCategory";
// import Start from "./components/pages/Starter";
import First from "./components/layouts/FirstModal";
// import Second from "./components/layouts/SecondModal";
// import Third from "./components/layouts/ThirdModal";
import { auth, db } from "./firebase";
import { useReducer } from "react";
import { reducer, initialState } from "./reducers/userReducer";
import emoji from './emoji';
// import Onboardings from "./components/layouts/First";
import FirstM from "./components/layouts/First";
import ForgotPasswordModal from "./components/pages/ForgotPasswordModal";
import { ThemeProvider } from '@material-ui/styles';
import { createTheme } from "@material-ui/core";
import CookieConsent from "react-cookie-consent";
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';



const theme = createTheme({
  breakpoints: {
    values: {
      xs: 525,
      sm: 730,
      md: 950,
      lg: 1280,
      xl: 1920,
    },
  },
})





//creating context
export const userContext = createContext();

function Routing() {
  const { state, dispatch } = useContext(userContext);
  console.log(state);

  // const history = useHistory();
  window.OneSignal = window.OneSignal || [];
  const OneSignal = window.OneSignal;
  useEffect(() => {
    var uid, email;
    var user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      uid = user['uid'];
      email = user['email'];
    } else {
      uid = null;
      email = null;
    }
    OneSignal.push(() => {
      OneSignal.init({
        appId: "2e4745be-413d-4aac-b2b7-a9b0c5223a13",
      });
      OneSignal.sendTag("uid", uid);
      OneSignal.setEmail(email)
        .then(function (emailId) {
          console.log("emailId: ", emailId);
        });
    });
  }, []);

  useEffect(() => {
    async function fetchdata() {
      const user = JSON.parse(localStorage.getItem("user"));
      console.log(user);
      if (user) {
        db.collection("posts")
          .get()
          .then((snapShot) => {
            const posts = snapShot.docs.map((doc) => {
              const data = doc.data();
              return { id: doc.id, ...data };
            });
            const currentUser = {
              user,
              posts,
            };
            dispatch({ type: "USER", payload: currentUser });
          });
      } else {
        //   if (!history.location.pathname.startsWith("/signup") && !state.uid) {
        //       history.push("/signin");
        // }
      }
    }
    fetchdata();
  }, []);
  // console.log(state);

  return (
    <Switch>
      {/* <Route exact path="/" component={Start} /> */}
      <Route exact path="/" component={Landing} />
      <Route exact path="/m" component={FirstM} />
      <Route exact path="/emoji" component={emoji} />
      <Route path="/signin" component={SignIn} />
      <Route path="/signup" component={SignUp} />
      <Route path="/home" component={Front} />
      <Route path="/folio/:id" component={Folio} />
      <Route path="/p/:postid/:id" component={FullScreen} />
      <Route path="/about" component={About} />
      <Route path="/faq" component={FAQs} />
      <Route path="/contact" component={Contact} />
      <Route path="/terms" component={TermsOfService} />
      <Route path="/privacy" component={PrivacyPolicy} />
      <Route path="/saved" component={Saved} />
      <Route path="/user" component={User} />
      <Route path="/upload" component={Upload} />
      <Route path="/attributes" component={Attributes} />
      <Route path="/file" component={File} />
      <Route path="/all" component={AllCategory} />
      <Route path="/settings" component={settings} />
      <Route path="/feedback" component={settingsFeed} />
      <Route path="/notification" component={settingsnotifi} />
      <Route path="/firstmodal" component={First} />
      <Route path="/searchresult" component={SearchedResult} />
      <Route path="/forgetpass" component={ForgotPasswordModal} />
    </Switch>
  );
}

function App() {
  const [state, dispatch] = useReducer(reducer, initialState);
  if (localStorage.getItem("allowed") === null) {
    localStorage.setItem("allowed", "0");
  }
  return (
    <ThemeProvider theme={theme}>
      <userContext.Provider value={{ state, dispatch }}>
        <React.Fragment>
          <BrowserRouter>
            <Routing />
          </BrowserRouter>
        </React.Fragment>
      </userContext.Provider>
      <CookieConsent
        location="bottom"
        buttonText="I understand"
        cookieName="myAwesomeCookieName2"
        style={{ background: "#F1F2F6", color: "#000" }}
        buttonStyle={{ color: "#000", background: "rgb(227 227 227)", fontSize: "14px", width: "150px" }}
        expires={365}
      >
        <ErrorOutlineIcon style={{ paddingBottom: "2px" }} />
        <span style={{ paddingLeft: "10px" }} >This website uses cookies to enhance the user experience. By continuing to use our website, you agree to our  <a style={{ color: "#115cfa" }} href="/privacy">Privacy Policy</a>{" "}</span>
      </CookieConsent>
    </ThemeProvider>

  );
}

export default App;
